<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-08-02 17:41:17
 * @LastEditors: 侯鹏许(houpengxu@qq.com)
 * @LastEditTime: 2020-03-09 16:25:54
 * @Description: file content
 如是分享引导页 很多客风格
 -->
<template>
  <div class="container">
    <div class="share_mask" @click="clickClose">
      <div class="share_line">
        <span></span>
        <img src="https://assets.rurushishi.com/activies/mfAct/sharelight.png" alt />
      </div>
      <div class="txt1">
        因为
        <span class="txt1_span">分享</span>，所以世界有了光！
      </div>
      <div class="txt2">好东西必须让更多朋友知道</div>
      <img
        class="tray"
        src="https://assets.rurushishi.com/yq-rs-make/components/share_guide3/tray.png"
        alt
      />
    </div>
  </div>
</template>

<script>
import util from "@/utils/utils";
import { mapState, mapMutations } from "vuex";
import createimg from "@/utils/createimg";
import upload from "@/utils/upload";

export default {
  components: {
  },
  props: {
    myProp: {}
  },
  data() {
    return {
    };
  },
  watch: {},
  computed: {
    ...mapState([
      "isInMiniProgram",
      "receiveSpreadInfo",
      "shareSpreadInfo",
      "pageInfo",
      "cardInfo",
      "userInfo",
      "hdkUserInfo"
    ])
  },
  methods: {
    clickClose: function() {
      this.$emit("close");
    },
  },
  created() {
  },
  mounted() {}
};
</script>
<style lang="css" scoped>
.share_mask {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 35;
}

.share_mask .share_line {
  position: absolute;
  top: 0px;
  right: 0;
  z-index: 9;
  width: 275px;
}

.share_mask .share_line > span {
  width: 4px;
  height: 4px;
  border-radius: 30%;
  background-color: #fff;
  position: absolute;
  bottom: 1rem;
  left: 1rem;
  display: inline-block;
  z-index: 8;
  -webkit-animation: sroll 3s infinite;
  animation: sroll 3s infinite;
}

.share_mask .share_line > img {
  width: 100%;
  animation: scaol 1.5s infinite;
}
@keyframes sroll {
  0% {
    transform: translate(0px, 0px);
    opacity: 1;
  }

  50% {
    opacity: 0.7;
  }

  100% {
    opacity: 0.3;
    transform: translate(180px, -200px);
  }
}

@keyframes scaol {
  0% {
    transform: scale(1);
    opacity: 1;
  }

  50% {
    transform: scale(1.05);
    opacity: 0.7;
  }

  80% {
    transform: scale(1.03);
    opacity: 0.75;
  }

  100% {
    opacity: 1;
    transform: scale(1);
  }
}

.share_mask .txt1 {
  position: absolute;
  top: 300px;
  left: 50%;
  margin-left: -100px;
  z-index: 9;
  width: 300px;
  color: #fffdd2;
  font-size: 16px;
}
.share_mask .txt1 .txt1_span {
  font-size: 20px;
  color: #dddc68;
}
.share_mask .txt2 {
  position: absolute;
  top: 330px;
  left: 50%;
  margin-left: -100px;
  z-index: 9;
  width: 300px;
  color: #fffdd2;
  font-size: 16px;
}
.tray {
  position: absolute;
  top: 320px;
  left: 50%;
  margin-left: -170px;
  z-index: 9;
  width: 350px;
  color: #fffdd2;
  font-size: 16px;
  z-index: -1;
}
.saveimg {
  position: absolute;
  bottom: 150px;
  left: 50%;
  margin-left: -100px;
  z-index: 9;
  padding: 10px 40px;
  border-radius: 20px;
  color: #fffdd2;
  font-size: 12px;
  border: 1px solid #f86e6f;
}
</style>